import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navigation from "../home/components/Navigation";
import Footer from "../home/components/Footer";

export default function ResourcesPage() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = 2;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Navigation />
      
      {/* Hero Section - More Dynamic */}
      <section className="relative pt-32 pb-24 sm:pt-40 sm:pb-32 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#f59e0b] via-[#ea580c] to-[#dc2626]"></div>
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <i className="ri-book-open-line text-white text-lg mr-2"></i>
            <span className="text-white text-sm font-semibold">Knowledge Hub</span>
          </div>
          
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Resources &amp; Updates
          </h1>
          
          <p className="text-base sm:text-lg text-white/90 leading-relaxed max-w-3xl mx-auto">
            We help owners, housing providers, and families navigate environmental risk in the real world. Explore our latest updates, guides, and healthy-home initiatives.
          </p>
        </div>
      </section>

      {/* Family First in Action Story - NEW SECTION */}
      <section className="py-20 sm:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Photo Side */}
            <div className="order-1 lg:order-1">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://static.readdy.ai/image/a76fc84099da4ca5f9486c73960e2672/c6f7084a7f6f92a2708cb5756965efbe.jpeg"
                  alt="The Mastykarz family smiling in front of the Ronald McDonald House Charities Tampa Bay sign"
                  className="w-full h-full object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-6">
                  <p className="text-white text-sm font-medium">
                    The Mastykarz family at Ronald McDonald House Charities – Tampa Bay, delivering Family First encouragement cards.
                  </p>
                </div>
              </div>
            </div>

            {/* Text Side */}
            <div className="order-2 lg:order-2">
              <div className="inline-flex items-center bg-gradient-to-r from-[#f59e0b] to-[#ea580c] px-4 py-2 rounded-full mb-6">
                <i className="ri-heart-3-line text-white text-lg mr-2"></i>
                <span className="text-white text-sm font-bold uppercase tracking-wide">Family First Initiative</span>
              </div>

              <h2 className="text-3xl sm:text-4xl font-bold text-black mb-6 leading-tight">
                Family First in Action: A Visit to Ronald McDonald House
              </h2>

              <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-8">
                As part of our Family First initiative, our family spent an afternoon at Ronald McDonald House Charities – Tampa Bay, delivering handwritten cards to families with children in the hospital. Our boys know what it feels like to be sick, to leave home, and to lean on the support of others—so they wanted to send a little strength and hope to kids and parents going through their own struggles.
              </p>

              {/* Quote Card */}
              <div className="relative bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border-l-4 border-[#f59e0b] shadow-lg">
                <div className="absolute top-6 left-6 text-6xl text-[#f59e0b]/20 font-serif leading-none">"</div>
                <div className="relative pl-8">
                  <p className="text-gray-800 text-base leading-relaxed mb-4 italic">
                    From our family to yours,
                  </p>
                  <p className="text-gray-700 text-base leading-relaxed mb-4">
                    When we were little, we went through a time when we were sick and had to leave our home. It wasn't easy, but with love, support, and care, things eventually got better.
                  </p>
                  <p className="text-gray-700 text-base leading-relaxed mb-4">
                    We just want you to know that we are thinking of you and praying for you as your family goes through its own tough time. You're not alone.
                  </p>
                  <p className="text-gray-700 text-base leading-relaxed mb-6">
                    We hope these cards bring a little comfort, strength, and hope to your day.
                  </p>
                  <div className="text-gray-800 font-semibold">
                    <p>With love,</p>
                    <p>Zach, Ethan and Joshua</p>
                    <p className="text-[#f59e0b]">The Mastykarz Family</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Update - erblue - Asymmetric Layout with Slider */}
      <section className="py-20 sm:py-28 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden">
        <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-[#f59e0b]/5 to-transparent"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="flex items-center justify-center mb-12">
            <div className="h-px bg-gradient-to-r from-transparent via-[#f59e0b] to-transparent w-24"></div>
            <h2 className="text-3xl sm:text-4xl font-bold text-black mx-6">
              Featured Updates
            </h2>
            <div className="h-px bg-gradient-to-r from-transparent via-[#f59e0b] to-transparent w-24"></div>
          </div>
          
          {/* Slider Container */}
          <div className="relative">
            {/* Slide 1 - erblue */}
            <div className={`transition-opacity duration-500 ${currentSlide === 0 ? 'opacity-100' : 'opacity-0 absolute inset-0 pointer-events-none'}`}>
              <div className="grid lg:grid-cols-2 gap-12 items-center">
                <div className="order-2 lg:order-1">
                  <div className="inline-flex items-center bg-[#f59e0b]/10 px-4 py-2 rounded-full mb-6">
                    <i className="ri-database-2-line text-[#f59e0b] text-lg mr-2"></i>
                    <span className="text-[#f59e0b] text-sm font-bold uppercase tracking-wide">Platform Innovation</span>
                  </div>
                  
                  <h3 className="text-3xl sm:text-4xl font-bold text-black mb-6 leading-tight">
                    Modernizing Environmental Data with erblue
                  </h3>
                  
                  <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-8">
                    LCA partners with erblue, a field–lab–report platform built from decades of real-world environmental project work. It helps our inspectors capture data once, move it cleanly to the lab, and generate clear, defensible reports in a fraction of the time.
                  </p>
                  
                  <a
                    href="https://www.erblue.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center bg-[#f59e0b] text-white px-8 py-4 rounded-xl text-base font-semibold hover:bg-[#d97706] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
                  >
                    Learn about erblue
                    <i className="ri-arrow-right-line ml-2"></i>
                  </a>
                </div>
                
                <div className="order-1 lg:order-2">
                  <div className="relative">
                    <div className="absolute inset-0 bg-gradient-to-br from-[#f59e0b] to-[#ea580c] rounded-3xl transform rotate-3"></div>
                    <div className="relative bg-white rounded-3xl p-8 shadow-2xl transform -rotate-1 hover:rotate-0 transition-transform duration-300">
                      <div className="space-y-4">
                        <div className="flex items-center space-x-3">
                          <div className="w-12 h-12 bg-[#f59e0b] rounded-xl flex items-center justify-center flex-shrink-0">
                            <i className="ri-file-chart-line text-white text-2xl"></i>
                          </div>
                          <div className="flex-1 h-4 bg-gray-200 rounded"></div>
                        </div>
                        <div className="flex items-center space-x-3">
                          <div className="w-12 h-12 bg-[#ea580c] rounded-xl flex items-center justify-center flex-shrink-0">
                            <i className="ri-test-tube-line text-white text-2xl"></i>
                          </div>
                          <div className="flex-1 h-4 bg-gray-200 rounded"></div>
                        </div>
                        <div className="flex items-center space-x-3">
                          <div className="w-12 h-12 bg-[#dc2626] rounded-xl flex items-center justify-center flex-shrink-0">
                            <i className="ri-file-text-line text-white text-2xl"></i>
                          </div>
                          <div className="flex-1 h-4 bg-gray-200 rounded"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Slide 2 - GoLeadSafe */}
            <div className={`transition-opacity duration-500 ${currentSlide === 1 ? 'opacity-100' : 'opacity-0 absolute inset-0 pointer-events-none'}`}>
              <div className="grid lg:grid-cols-2 gap-12 items-center">
                <div className="order-2 lg:order-1">
                  <div className="inline-flex items-center bg-[#ea580c]/10 px-4 py-2 rounded-full mb-6">
                    <i className="ri-shield-check-line text-[#ea580c] text-lg mr-2"></i>
                    <span className="text-[#ea580c] text-sm font-bold uppercase tracking-wide">Compliance Initiative</span>
                  </div>
                  
                  <h3 className="text-3xl sm:text-4xl font-bold text-black mb-6 leading-tight">
                    GoLeadSafe: Lead Compliance Made Easier
                  </h3>
                  
                  <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-8">
                    GoLeadSafe helps housing providers and property managers stay ahead of changing lead laws—making it simpler to schedule inspections, track documentation, and keep each property's lead status in one place.
                  </p>
                  
                  <a
                    href="https://www.goleadsafe.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center bg-[#ea580c] text-white px-8 py-4 rounded-xl text-base font-semibold hover:bg-[#dc2626] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
                  >
                    Visit GoLeadSafe.com
                    <i className="ri-arrow-right-line ml-2"></i>
                  </a>
                </div>
                
                <div className="order-1 lg:order-2">
                  <div className="relative">
                    <div className="absolute inset-0 bg-gradient-to-br from-[#ea580c] to-[#dc2626] rounded-3xl transform rotate-3"></div>
                    <div className="relative bg-white rounded-3xl p-8 shadow-2xl transform -rotate-1 hover:rotate-0 transition-transform duration-300">
                      <div className="space-y-4">
                        <div className="flex items-center space-x-3">
                          <div className="w-12 h-12 bg-[#ea580c] rounded-xl flex items-center justify-center flex-shrink-0">
                            <i className="ri-calendar-check-line text-white text-2xl"></i>
                          </div>
                          <div className="flex-1 h-4 bg-gray-200 rounded"></div>
                        </div>
                        <div className="flex items-center space-x-3">
                          <div className="w-12 h-12 bg-[#dc2626] rounded-xl flex items-center justify-center flex-shrink-0">
                            <i className="ri-file-shield-line text-white text-2xl"></i>
                          </div>
                          <div className="flex-1 h-4 bg-gray-200 rounded"></div>
                        </div>
                        <div className="flex items-center space-x-3">
                          <div className="w-12 h-12 bg-[#b91c1c] rounded-xl flex items-center justify-center flex-shrink-0">
                            <i className="ri-home-gear-line text-white text-2xl"></i>
                          </div>
                          <div className="flex-1 h-4 bg-gray-200 rounded"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Navigation Arrows */}
            <button
              onClick={prevSlide}
              className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-[#f59e0b] hover:text-white transition-all duration-300 z-10 cursor-pointer group"
              aria-label="Previous slide"
            >
              <i className="ri-arrow-left-line text-2xl text-gray-700 group-hover:text-white"></i>
            </button>
            <button
              onClick={nextSlide}
              className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-[#f59e0b] hover:text-white transition-all duration-300 z-10 cursor-pointer group"
              aria-label="Next slide"
            >
              <i className="ri-arrow-right-line text-2xl text-gray-700 group-hover:text-white"></i>
            </button>

            {/* Dots Navigation */}
            <div className="flex justify-center gap-3 mt-8">
              {[...Array(totalSlides)].map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                    currentSlide === index
                      ? 'bg-[#f59e0b] w-8'
                      : 'bg-gray-300 hover:bg-gray-400'
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* PureHome & Healthy Homes - Side by Side with Color Accents */}
      <section className="py-20 sm:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center bg-gradient-to-r from-[#f59e0b] to-[#ea580c] px-6 py-3 rounded-full mb-6">
              <i className="ri-home-heart-line text-white text-xl mr-3"></i>
              <span className="text-white text-sm font-bold uppercase tracking-wide">Healthy Homes Initiative</span>
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-black">
              PureHome &amp; Healthy Homes
            </h2>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-8">
            {/* PureHome Card - Orange Accent */}
            <div className="group relative bg-gradient-to-br from-[#f59e0b] to-[#ea580c] rounded-3xl p-1 hover:shadow-2xl transition-all duration-300">
              <div className="bg-white rounded-3xl p-8 h-full">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-[#f59e0b] to-[#ea580c] rounded-2xl flex items-center justify-center mr-4 flex-shrink-0 shadow-lg">
                    <i className="ri-home-smile-2-line text-white text-3xl"></i>
                  </div>
                  <h3 className="text-2xl sm:text-3xl font-bold text-black">
                    PureHome: Bringing Building Health Home
                  </h3>
                </div>
                
                <p className="text-base text-gray-700 leading-relaxed">
                  PureHome focuses on the places that matter most—where families sleep, play, and grow. We're working to make healthy-home assessments more accessible, more understandable, and easier to act on for everyday families.
                </p>
              </div>
            </div>

            {/* Healthy Homes Card - Red Accent */}
            <div className="group relative bg-gradient-to-br from-[#ea580c] to-[#dc2626] rounded-3xl p-1 hover:shadow-2xl transition-all duration-300">
              <div className="bg-white rounded-3xl p-8 h-full">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-[#ea580c] to-[#dc2626] rounded-2xl flex items-center justify-center mr-4 flex-shrink-0 shadow-lg">
                    <i className="ri-parent-line text-white text-3xl"></i>
                  </div>
                  <h3 className="text-2xl sm:text-3xl font-bold text-black">
                    Healthy Homes Where Kids Live, Learn, and Sleep
                  </h3>
                </div>
                
                <p className="text-base text-gray-700 leading-relaxed">
                  From lead and asbestos to moisture and indoor air quality, small issues in a home or daycare can have big impacts on children. We share practical guidance to help owners and caregivers understand risks, ask better questions, and choose the right next step.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Guides & Regulatory Resources - Staggered Cards */}
      <section className="py-20 sm:py-28 bg-gradient-to-br from-gray-50 via-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-black mb-4">
              Guides &amp; Regulatory Resources
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Practical tools and guidance to help you navigate environmental compliance
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {/* NJ Lead Law */}
            <div className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border-t-4 border-[#f59e0b] hover:-translate-y-2">
              <div className="w-14 h-14 bg-gradient-to-br from-[#f59e0b] to-[#ea580c] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-file-list-3-line text-white text-2xl"></i>
              </div>
              
              <h3 className="text-xl font-bold text-black mb-4">
                NJ Lead Law: What Property Owners Need to Know
              </h3>
              
              <p className="text-sm text-gray-700 leading-relaxed mb-6">
                A plain-language overview of New Jersey's lead inspection requirements for rental properties, including timelines, inspection options, and how LCA Group can help you stay compliant.
              </p>
              
              <Link
                to="/nj-lead-inspections"
                className="inline-flex items-center text-[#f59e0b] font-bold hover:text-[#d97706] transition-colors cursor-pointer text-sm group-hover:translate-x-2 transition-transform duration-300"
              >
                Read NJ Lead Law overview
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>

            {/* Inspection Prep */}
            <div className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border-t-4 border-[#ea580c] hover:-translate-y-2 md:mt-8 relative">
              <div className="absolute top-4 right-4 bg-gradient-to-r from-[#ea580c] to-[#dc2626] text-white text-xs font-bold px-3 py-1 rounded-full">
                Coming Soon
              </div>
              
              <div className="w-14 h-14 bg-gradient-to-br from-[#ea580c] to-[#dc2626] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-checkbox-multiple-line text-white text-2xl"></i>
              </div>
              
              <h3 className="text-xl font-bold text-black mb-4">
                Preparing for Lead, Asbestos, or IAQ Inspections
              </h3>
              
              <p className="text-sm text-gray-700 leading-relaxed mb-6">
                A step-by-step checklist for homeowners, landlords, and facility managers to get ready for an environmental inspection—and what to expect on the day of the visit.
              </p>
              
              <span className="inline-flex items-center text-gray-400 font-bold text-sm">
                Download inspection prep checklist
                <i className="ri-arrow-right-line ml-2"></i>
              </span>
            </div>

            {/* Portfolio Programs */}
            <div className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border-t-4 border-[#dc2626] hover:-translate-y-2 relative">
              <div className="absolute top-4 right-4 bg-gradient-to-r from-[#dc2626] to-[#b91c1c] text-white text-xs font-bold px-3 py-1 rounded-full">
                Coming Soon
              </div>
              
              <div className="w-14 h-14 bg-gradient-to-br from-[#dc2626] to-[#b91c1c] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-building-line text-white text-2xl"></i>
              </div>
              
              <h3 className="text-xl font-bold text-black mb-4">
                Scaling from One Building to Thousands
              </h3>
              
              <p className="text-sm text-gray-700 leading-relaxed mb-6">
                How we use standardized methods, digital data, and program playbooks to help P3, military housing, and portfolio owners manage environmental risk consistently across large portfolios.
              </p>
              
              <span className="inline-flex items-center text-gray-400 font-bold text-sm">
                Learn about portfolio programs
                <i className="ri-arrow-right-line ml-2"></i>
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* LCA Group News - Modern Grid */}
      <section className="py-20 sm:py-28 bg-black text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#f59e0b] rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#ea580c] rounded-full blur-3xl"></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="text-center mb-16">
            <div className="inline-flex items-center bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full mb-6">
              <i className="ri-newspaper-line text-[#f59e0b] text-xl mr-3"></i>
              <span className="text-white text-sm font-bold uppercase tracking-wide">Latest News</span>
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-white">
              LCA Group News
            </h2>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {/* News Item 1 */}
            <div className="group bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 hover:bg-white/10 hover:border-[#f59e0b]/50 transition-all duration-300 relative">
              <div className="absolute top-4 right-4 bg-gradient-to-r from-[#f59e0b] to-[#ea580c] text-white text-xs font-bold px-3 py-1 rounded-full">
                Coming Soon
              </div>
              
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-[#f59e0b] rounded-xl flex items-center justify-center mr-3 flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-map-pin-line text-white text-xl"></i>
                </div>
                <span className="text-xs font-bold text-[#f59e0b] uppercase tracking-wide">Company Update</span>
              </div>
              
              <h3 className="text-xl font-bold text-white mb-4">
                LCA Group opens Southeast office in Tampa, FL
              </h3>
              
              <p className="text-sm text-gray-300 leading-relaxed mb-6">
                Expanding our regional presence to better serve clients across Florida and the Southeast with faster response times and local expertise in environmental consulting services.
              </p>
              
              <span className="inline-flex items-center text-gray-400 font-bold text-sm">
                Read more
                <i className="ri-arrow-right-line ml-2"></i>
              </span>
            </div>

            {/* News Item 2 */}
            <div className="group bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 hover:bg-white/10 hover:border-[#ea580c]/50 transition-all duration-300 relative">
              <div className="absolute top-4 right-4 bg-gradient-to-r from-[#ea580c] to-[#dc2626] text-white text-xs font-bold px-3 py-1 rounded-full">
                Coming Soon
              </div>
              
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-[#ea580c] rounded-xl flex items-center justify-center mr-3 flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-flask-line text-white text-xl"></i>
                </div>
                <span className="text-xs font-bold text-[#ea580c] uppercase tracking-wide">Technology</span>
              </div>
              
              <h3 className="text-xl font-bold text-white mb-4">
                erblue expands to support new laboratory partners
              </h3>
              
              <p className="text-sm text-gray-300 leading-relaxed mb-6">
                Our field-to-lab platform now integrates with additional certified laboratories nationwide, streamlining data workflows and accelerating turnaround times for environmental testing projects.
              </p>
              
              <span className="inline-flex items-center text-gray-400 font-bold text-sm">
                Read more
                <i className="ri-arrow-right-line ml-2"></i>
              </span>
            </div>

            {/* News Item 3 */}
            <div className="group bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 hover:bg-white/10 hover:border-[#dc2626]/50 transition-all duration-300 relative">
              <div className="absolute top-4 right-4 bg-gradient-to-r from-[#dc2626] to-[#b91c1c] text-white text-xs font-bold px-3 py-1 rounded-full">
                Coming Soon
              </div>
              
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-[#dc2626] rounded-xl flex items-center justify-center mr-3 flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-shield-check-line text-white text-xl"></i>
                </div>
                <span className="text-xs font-bold text-[#dc2626] uppercase tracking-wide">Initiative</span>
              </div>
              
              <h3 className="text-xl font-bold text-white mb-4">
                GoLeadSafe launches to make lead compliance more accessible
              </h3>
              
              <p className="text-sm text-gray-300 leading-relaxed mb-6">
                Introducing a new initiative to make lead-safe compliance more affordable and accessible for property owners, helping families stay safe while simplifying the inspection and documentation process.
              </p>
              
              <span className="inline-flex items-center text-gray-400 font-bold text-sm">
                Read more
                <i className="ri-arrow-right-line ml-2"></i>
              </span>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
